// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xBdT","question":"styles_question__1kx5j","inputVisibleButton":"styles_inputVisibleButton__11EjP","note":"styles_note__1v_SA"};